module.exports = __webpack_public_path__ + "static/media/sectur.64c759ea.webp";